const keyStr = import.meta.env.VITE_ENCRYPTION_KEY;
const keyData = new TextEncoder().encode(keyStr.padEnd(32).slice(0, 32));
const iv = new Uint8Array(16); // 16 bytes for AES-CBC

export const encrypt = async (payload: any): Promise<string> => {
  const encoded = new TextEncoder().encode(JSON.stringify(payload));
  const key = await crypto.subtle.importKey("raw", keyData, { name: "AES-CBC" }, false, ["encrypt"]);
  const cipher = await crypto.subtle.encrypt({ name: "AES-CBC", iv }, key, encoded);
  return btoa(String.fromCharCode(...new Uint8Array(cipher)));
};

export const decrypt = async <T>(b64: string): Promise<T> => {
  const encrypted = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
  const key = await crypto.subtle.importKey("raw", keyData, { name: "AES-CBC" }, false, ["decrypt"]);
  const decrypted = await crypto.subtle.decrypt({ name: "AES-CBC", iv }, key, encrypted);
  return JSON.parse(new TextDecoder().decode(decrypted));
};
